/** Google (and styled) third-party sign-in button for the login page. */
import GoogleGLogo from '@/features/auth/GoogleGLogo';

/**
 * @param {{ label: string, onClick: () => void, disabled?: boolean }} props
 */
const AuthProviderButton = ({ label, onClick, disabled = false }) => (
  <button
    type="button"
    className="auth-provider-button google-sign-in-button"
    onClick={onClick}
    disabled={disabled}
  >
    <GoogleGLogo />
    <span className="auth-provider-button-label">{label}</span>
  </button>
);

export default AuthProviderButton;
